import isObject from 'lodash/isObject'

export function reportToSentry (error, { context, extras, level = 'error' } = {}) {
  if (!process.env.SENTRY_BROWSER_DSN) {
    return
  }

  if (error.isReportedToSentry) {
    return
  }

  const Sentry = require('@sentry/browser')

  Sentry.withScope(scope => {
    if (context) {
      setFeathersContext(scope, context)
    }

    if (extras && isObject(extras)) {
      scope.setExtras(extras)
    }

    // If the error has a request_id set it as tag, so we can track errors accross backend and frontend.
    if (error.data && error.data.request_id) {
      scope.setTag('request_id', error.data.request_id)
    }

    if (error instanceof Error) {
      Sentry.captureException(error)
    } else {
      scope.setLevel(level)
      Sentry.captureMessage(error)
    }
  })
}

function setFeathersContext (scope, context) {
  const { path, method, data, result, params } = context

  scope.setTag('feathers.provider', context.params.provider)
  scope.setExtra('feathers.path', `${path}@${method}`)
  scope.setExtra('feathers.params.query', params.query)

  if (params.connection) {
    scope.setExtra('feathers.params.connection', {
      ...params.connection.authentication,
      ...params.connection.headers
    })
  }

  if (data) scope.setExtra('feathers.data', data)
  if (result) scope.setExtra('feathers.result', result)
}
